/* eslint-disable react/jsx-no-constructed-context-values */
import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./index.scss";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { store } from "./store/store";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

(window as any).GM_API_KEY = "AIzaSyB6uCNF8m7C0eL4iZ9caubUtlfU8ZT0mSY";

const { baseUrl: baseURL, isSuperadmin } = JSON.parse(
  (document as any).querySelector("#app").dataset.page
).props;

const router = createBrowserRouter(routes, {
  basename: `${baseURL}/workflows`,
});

export default function Workflows() {
  return (
    <div
      className="App"
      style={{
        height: isSuperadmin ? "calc(100vh - 84px)" : "calc(100vh - 44px)",
      }}
    >
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

/*
React Diagrams
https://github.com/projectstorm/react-diagrams

diagram engine settings in Diagrams.jsx file



*/
